import { Surface } from '@storebrand-digital/pretzel';

interface Props {
  locale: 'en' | 'no';
}

export function WebViewFormFooter({ locale }: Props) {
  return (
    <footer className="text-center">
      <Surface className="p-20" isInheritedLayer>
        <a
          className="text-grey-700 font-body-small"
          href="https://www.storebrand.no/om-storebrand/sikkerhet-og-personvern/personvern?displaymode=app"
          data-trackid="link-web_view_footer_privacy_policy|Behandling av personopplysninger"
        >
          {locale === 'en'
            ? 'Processing of personal data'
            : 'Behandling av personopplysninger'}
        </a>
      </Surface>
    </footer>
  );
}
